'use client';
import React from 'react';
import { useField } from 'formik';
import Image from '@repo/ui/src/components/Image';
import { readFile } from '@utils/image';
import { Input } from '@components/Form';

interface Props {
  accept?: string;
  id: string;
  name: string;
  src?: string;
  photoUpload?: string;
  isEditing?: boolean;
}

const DEFAULT_SRC = '/icons/account.svg';

const ImageUpload = ({ src, ...props }: Props) => {
  const [, , helpers] = useField(props);
  const [fileUrl, setFileUrl] = React.useState(src ?? DEFAULT_SRC);

  React.useEffect(() => {
    //@ts-expect-error ts doesn't like it
    if (!(src instanceof File)) {
      setFileUrl(src ?? DEFAULT_SRC);
    }
  }, [src]);

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const file = e?.target?.files?.[0];

    if (file) {
      const sourceImage = await readFile(file);
      setFileUrl(sourceImage);
      helpers.setValue(file);
    }
  };

  return (
    <div>
      <div className="tw-bg-warm-300 tw-overflow-hidden tw-w-[150px] tw-h-[150px] tw-rounded-full tw-relative -tw-z-1">
        <div className="tw-relative tw-w-full tw-h-full">
          <Image src={fileUrl} alt="image preview" layout="fill" objectFit="cover" />
        </div>
      </div>
      {props.isEditing && (
        <Input
          type="file"
          inputStyles="tw-hidden"
          onChange={handleChange}
          {...props}
          value={undefined}
          label={props.photoUpload}
          labelStyles="tw-underline tw-text-center tw-cursor-pointer tw-pt-2"
        />
      )}
    </div>
  );
};

export default ImageUpload;
